<template>
  <div>
    <template v-if="Object.keys(limitedQmList).length > 0">
      <quiz-content v-for="(qm, qmIndex) in limitedQmList" :key="`quiz_content_${qmIndex}`">
        <div class="quiz_header_answered">
          <quiz-header-text>回答済み</quiz-header-text>
          <quiz-release-date :timestamp="qm.start_datetime" />
        </div>
        <quiz-body>
          <quiz-question-image :qm_id="qm.id"/>
          <quiz-question>
            <quiz-text :text="qm.quiz_text" />
            <div class="quiz_answer">
              <span>{{getAnsweredQsmSelection(qm.quiz_selections_masters_group_id)}}</span>
            </div>
          </quiz-question>
          <quiz-answer-image :qm_id="qm.id"/>
          <quiz-question>
            <quiz-text :text="qm.correct_text" />
            <quiz-button :hint_url="qm.hint_url" text="くわしく見る" @clickQuizButton="clickQuizButtonHandler(qm.id)"/>
          </quiz-question>
          <quiz-term :limited_flag="qm.limited_flag" :timestamp="qm.end_datetime"/>
        </quiz-body>
      </quiz-content>
    </template>
    <template v-else>
      <quiz-no-list text="クリアしたクイズはありません。" />
    </template>
  </div>
</template>

<script>
import QuizAnswerImage from '@/components/QuizAnswerImage'
import HintClickable from '@/components/mixins/HintClickable'
import AnsweredListable from '@/components/mixins/AnsweredListable'
import QuizNoList from '@/components/QuizNoList'

export default {
  name: 'AnsweredList',
  mixins: [AnsweredListable, HintClickable],
  components: {
    QuizAnswerImage,
    QuizNoList
  },
  methods: {
    getAnsweredQsmSelection (groupId) {
      const qsmList = this.qsm_lists[groupId]
      const keys = Object.keys(qsmList)
      const len = keys.length
      for (let i = 0; i < len; i += 1) {
        const key = keys[i]
        const qsm = qsmList[key]
        if (qsm.correct_flag) {
          return qsm.selection
        }
      }
      return ''
    }
  }
}
</script>

<style scoped>
  .quiz_header_answered {
    height: 70px;
    color: #ec8dae;
    background: #fff;
    border-radius: 48px 0 0 0;
    position: relative;
  }

  @media screen and (max-width: 767px) {
    .quiz_header_answered {
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -webkit-align-items: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -webkit-justify-content: center;
      -ms-flex-pack: center;
      justify-content: center;
    }
  }

  .quiz_header_answered::before {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 3px;
    content: "";
    background: url("../assets/quiz_plt_deco10_pink.png") no-repeat center bottom;
  }

  @media screen and (max-width: 767px) {
    .quiz_header_answered::before {
      background: url("../assets/quiz_plt_deco00_pink_sp.png") no-repeat center bottom;
      background-size: 100%;
    }
  }

  .quiz_answer {
    width: 372px;
    margin: 44px auto;
    padding: 0 0 10px 50px;
    position: relative;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #676767;
    border-bottom: 2px solid #ec8dae;
    font-size: 18px;
    line-height: 18px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
  }

  @media screen and (max-width: 767px) {
    .quiz_answer {
      width: 100%;
    }
  }

  .quiz_answer:before {
    color: #ec8dae;
    font-size: 24px;
    position: absolute;
    left: 0;
    bottom: 10px;
    content: "答え";
  }

  .quiz_answer > span {
    text-align: center;
  }
</style>
